module.exports = __webpack_public_path__ + "img/hr-V-R-3-unload-connect-shadow.ad7ca6e4.png";